class VirtualTryOn {
  constructor(container) {
    this.container = container;
    this.uploadArea = container.querySelector('.vton-upload-area');
    this.fileInput = container.querySelector('#vton-file-input');
    this.previewImg = container.querySelector('.vton-preview-img');
    this.tryOnBtn = container.querySelector('.vton-btn');
    this.productCards = container.querySelectorAll('.vton-product-card');
    this.loadingOverlay = container.querySelector('.vton-loading');
    this.statusMsg = container.querySelector('.vton-status-msg');
    this.recommendationArea = container.querySelector('.vton-recommendation');
    this.recommendationText = container.querySelector('.vton-recommendation p');

    this.selectedProductId = null;
    this.userImage = null;

    this.init();
  }

  init() {
    this.uploadArea.addEventListener('click', () => this.fileInput.click());
    this.fileInput.addEventListener('change', (e) => this.handleFileUpload(e));

    this.productCards.forEach(card => {
      card.addEventListener('click', () => this.selectProduct(card));
    });

    this.tryOnBtn.addEventListener('click', () => this.performTryOn());

    // Drag and drop support
    this.uploadArea.addEventListener('dragover', (e) => {
      e.preventDefault();
      this.uploadArea.classList.add('drag-over');
    });

    this.uploadArea.addEventListener('dragleave', () => {
      this.uploadArea.classList.remove('drag-over');
    });

    this.uploadArea.addEventListener('drop', (e) => {
      e.preventDefault();
      this.uploadArea.classList.remove('drag-over');
      if (e.dataTransfer.files.length) {
        this.fileInput.files = e.dataTransfer.files;
        this.handleFileUpload({ target: this.fileInput });
      }
    });
  }

  handleFileUpload(e) {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      this.userImage = event.target.result;
      this.previewImg.src = this.userImage;
      this.previewImg.style.display = 'block'; // Show the image
      this.uploadArea.classList.add('has-image');
      this.checkReady();
      this.analyzeImage(this.userImage);
    };
    reader.readAsDataURL(file);
  }

  selectProduct(card) {
    this.productCards.forEach(c => c.classList.remove('active'));
    card.classList.add('active');
    this.selectedProductId = card.dataset.productId;
    this.checkReady();
  }

  checkReady() {
    if (this.userImage && this.selectedProductId) {
      this.tryOnBtn.disabled = false;
    } else {
      this.tryOnBtn.disabled = true;
    }
  }

  async performTryOn() {
    if (!this.userImage || !this.selectedProductId) return;

    this.loadingOverlay.classList.add('active');
    
    const steps = [
      "Analyzing body proportions...",
      "Mapping garment flow...",
      "Adjusting lighting...",
      "Sewing your digital look..."
    ];

    for (let step of steps) {
      this.statusMsg.textContent = step;
      await new Promise(r => setTimeout(r, 1200));
    }

    // --- Start Digital Overlay Logic ---
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const userImg = new Image();
    const shirtImg = new Image();

    // Find the current active shirt card's image
    const activeCard = Array.from(this.productCards).find(c => c.dataset.productId === this.selectedProductId);
    const shirtSrc = activeCard ? activeCard.querySelector('img').src : '';

    await Promise.all([
      new Promise(r => { userImg.onload = r; userImg.src = this.userImage; }),
      new Promise(r => { shirtImg.onload = r; shirtImg.src = shirtSrc; })
    ]);

    // Set canvas to user image size
    canvas.width = userImg.width;
    canvas.height = userImg.height;

    // Draw user image
    ctx.drawImage(userImg, 0, 0);

    // DRAW OVERLAY (Simple version: centered and blended)
    const shirtWidth = canvas.width * 0.6; // Scale shirt to 60% of person width
    const shirtHeight = (shirtImg.height / shirtImg.width) * shirtWidth;
    const x = (canvas.width - shirtWidth) / 2;
    const y = canvas.height * 0.35; // Position at chest level (approx)

    // Use "multiply" or "overlay" blending for a more integrated look if shirts have backgrounds
    // Best results achieved with transparent PNGs (no blending needed)
    ctx.globalAlpha = 0.85; 
    ctx.drawImage(shirtImg, x, y, shirtWidth, shirtHeight);
    ctx.globalAlpha = 1.0;

    // Final result
    this.previewImg.src = canvas.toDataURL('image/png');
    this.loadingOverlay.classList.remove('active');
    
    // Add a success indicator
    const successMsg = document.createElement('div');
    successMsg.textContent = "AI Preview Generated!";
    successMsg.style.cssText = "position: absolute; top: 10px; right: 10px; background: #27ae60; color: #fff; padding: 5px 15px; border-radius: 20px; font-size: 0.8rem; z-index: 5;";
    this.uploadArea.appendChild(successMsg);
    setTimeout(() => successMsg.remove(), 3000);
  }

  analyzeImage(imgData) {
    // Mock image analysis for recommendation
    // real implementation could use a hidden canvas to get average color
    const recommendations = [
      "This color will complement your skin tone perfectly!",
      "A classic choice that works well for your build.",
      "The patterns on this shirt will add a great dynamic to your look.",
      "Perfect for a sophisticated yet casual vibe."
    ];
    
    const randomRec = recommendations[Math.floor(Math.random() * recommendations.length)];
    
    setTimeout(() => {
      this.recommendationText.textContent = randomRec;
      this.recommendationArea.classList.add('active');
    }, 1000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const vtonContainer = document.querySelector('.vton-container');
  if (vtonContainer) {
    new VirtualTryOn(vtonContainer);
  }
});
